<template>
  
  <SubHeading :home="home" :tabs="visibleTabs" :shorts="true" :currTab="currTab" color="cyan darken-3" @active="handleActive" />

  <!-- breadcrumbs   -->
  <nav class="sba-collection-breadcrumb z-depth-0">
    <div class="container nav-wrapper">
      <div class="sba-collection-breadcrumb-row">
        <router-link to="/" class="breadcrumb sba-collection-crumb teal-text">
          <i class="material-icons">home</i>
          <span>Dashboard</span>
        </router-link>
        <i class="material-icons sba-collection-crumb-separator">chevron_right</i>
        <span v-if="currTab?.title?.toLowerCase()?.includes('home')" class="breadcrumb sba-collection-crumb blue-grey-text">
          <span>Compliance Home</span>
        </span>
        <a v-else href="!#" class="breadcrumb sba-collection-crumb blue-grey-text"
          @click.prevent="handleActive(tabs.find(x => x.title.includes('Home')))">
          <span>Compliance Home</span>
        </a>
        <template v-if="!currTab?.title?.toLowerCase()?.includes('home')">
          <i class="material-icons sba-collection-crumb-separator">chevron_right</i>
          <span class="breadcrumb sba-collection-crumb blue-grey-text">
            <span>{{ currTab?.title?.split(" ")[0] }}</span>
          </span>
        </template>
        <span class="sba-collection-context">{{ breadcrumbContext }}</span>
      </div>
    </div>
  </nav>

<!-- search layer -->
<!-- <div class="grey lighten-4">
  <div class="container section"></div>
</div> -->

<!-- Top -->
<div id="top"></div>

    <div class="container compliance-page-shell">
      <div class="compliance-workbench">
        <LoadingDiv v-if="!isReady" />

        <template v-else>

        <div class="compliance-view-shell sba-slide-in" :key="currTab?.id">
          <CollectionModuleLanding
            v-if="currTab?.title.toLowerCase().includes('home')"
            moduleName="Compliance"
            heading="Compliance Review Desk"
            description="Review claims, invoices, and onboarding approvals with risk-aware controls."
            scopeLabel="Risk Control"
            accent="amber"
            :tabs="tabs"
            :cardCopy="landingCards"
            @active="handleActive"
          />

          <!-- Invoices -->
          <InvoicesDiv
            :resetKey="invoicesResetKey"
            v-if="currTab?.title.toLowerCase().includes('invoices')"
          />

          <!-- Claims -->
          <ClaimsDiv
            :resetKey="claimsResetKey"
            v-if="currTab?.title.toLowerCase().includes('claims')"
          />

          <!-- Client -->
          <ClientDiv
            v-if="currTab?.title.toLowerCase().includes('client')"
          />

          <!-- Provider -->
          <ProviderDiv
            v-if="currTab?.title.toLowerCase().includes('provider')"
          />
        </div>

          <!-- </div> -->
        </template>
      </div>
    </div>
  </template>
    
  <script>
  import { computed, onMounted, ref, watch } from "vue";
  import { useRoute } from "vue-router";
  import useModuleNavigation from "@/composables/useModuleNavigation";
  import SubHeading from "@/components/HeaderSubDiv.vue";
  import LoadingDiv from "@/components/LoadingDiv.vue";
  import InvoicesDiv from "@/components/compliance/ComplianceInvoicesComponent.vue";
  import ClaimsDiv from "@/components/compliance/ComplianceClaimsComponent.vue";
  import ClientDiv from "@/components/approvals/ClientApprovalComponent.vue";
  import ProviderDiv from "@/components/approvals/ProviderApprovalComponent.vue";
  import CollectionModuleLanding from "@/components/collection/CollectionModuleLandingComponent.vue";
  import { clientAuth, providerAuth } from '@/laravel/config';
  
  export default {
    name: "financeHome",
    components: {
      SubHeading,
      LoadingDiv,
      InvoicesDiv,
      ClaimsDiv,
      ClientDiv,
      ProviderDiv,
      CollectionModuleLanding,
    },
    setup() {
      const route = useRoute();
      const home = ref(null);
      const isReady = ref(true);
      const error = ref(null);
      const currTab = ref(null);
      const invoicesResetKey = ref(0);
      const claimsResetKey = ref(0);
      const tabs = ref([]);
      const { activateLocalTab } = useModuleNavigation();
      const visibleTabs = computed(() => tabs.value.filter((tab) => !tab.title?.includes("Home")));
      const breadcrumbContext = computed(() => {
        if (currTab.value?.title?.toLowerCase()?.includes("home")) {
          return `${currTab.value?.name || "Compliance"} Workspace`;
        }

        return `${currTab.value?.title || "Compliance"} Workspace`;
      });
      const landingCards = {
        "Claims Review": {
          icon: "policy",
          description: "Review claims with compliance context and flag issues for correction.",
        },
        "Invoices Payment": {
          icon: "receipt_long",
          description: "Review invoice payment actions that require compliance visibility.",
        },
        "Client Approvals": {
          icon: "business",
          description: "Review client onboarding approvals before activation.",
        },
        "Provider Approvals": {
          icon: "local_hospital",
          description: "Review provider onboarding approvals before activation.",
        },
      };
      const routeSections = {
        "claims-review": "Claims Review",
        "invoices-payment": "Invoices Payment",
        "client-approvals": "Client Approvals",
        "provider-approvals": "Provider Approvals",
      };
  
      // start
      onMounted(() => {
        // page name
        document.title = "Compliance | EasyHMO";
      });
  
      // Initiate
      onMounted(() => {
      // load tab
      tabs.value.push({ id: tabs.value.length + 1, name: "Compliance", title: "Home", icon: null, url: null, hash: null, });
      tabs.value.push({ id: tabs.value.length + 1, name: "Compliance", title: "Claims Review", icon: null, url: null, hash: null, });
      tabs.value.push({ id: tabs.value.length + 1, name: "Compliance", title: "Invoices Payment", icon: null, url: null, hash: null, });

      // auth client
      if (clientAuth === 'compliance') {
        tabs.value.push({ id: tabs.value.length + 1, name: "Compliance", title: "Client Approvals", icon: null, url: null, hash: null, })
      }
      
       // auth provider
      if (providerAuth === 'compliance') {
        tabs.value.push({ id: tabs.value.length + 1, name: "Compliance", title: "Provider Approvals", icon: null, url: null, hash: null, })
      }

      // set default
      currTab.value = tabs.value.find(x => x.title.includes("Home"));

      // set home
      home.value = tabs.value.find(x => x.title.includes("Home"));

      activateRouteSection();
      });
  
      // handle curr status
      const handleActive = (tab) => {
        if (tab?.title?.toLowerCase()?.includes("invoices")) {
          invoicesResetKey.value++;
        }

        if (tab?.title?.toLowerCase()?.includes("claims")) {
          claimsResetKey.value++;
        }

        activateLocalTab(tab, currTab);
      };

      function activateRouteSection() {
        const targetTitle = routeSections[route.query.section];
        const targetTab = tabs.value.find(x => x.title === targetTitle);

        if (targetTab && currTab.value?.id !== targetTab.id) {
          handleActive(targetTab);
        }
      }

      watch(
        () => route.query.section,
        () => activateRouteSection()
      );
  
 
      return {
        home,
        handleActive,
        isReady,
        error,
        currTab,
        invoicesResetKey,
        claimsResetKey,
        tabs,
        visibleTabs,
        breadcrumbContext,
        landingCards,
      };
    },
  };
  </script>

  <style scoped>
  .compliance-page-shell {
    margin-top: -14px;
    padding-bottom: 44px;
    padding-top: 0;
    position: relative;
    z-index: 1;
  }

  .compliance-workbench {
    color: #263238;
  }

  .compliance-view-shell :deep(.collection-landing-head),
  .compliance-view-shell :deep(.workflow-card),
  .compliance-view-shell :deep(.premium-queue-head),
  .compliance-view-shell :deep(.claim-batch-row),
  .compliance-view-shell :deep(.claim-detail-card),
  .compliance-view-shell :deep(.empty-review-state),
  .compliance-view-shell :deep(.invoice-review-head),
  .compliance-view-shell :deep(.invoice-filter-card),
  .compliance-view-shell :deep(.invoice-list-card),
  .compliance-view-shell :deep(.invoice-row-card),
  .compliance-view-shell :deep(.invoice-empty-state),
  .compliance-view-shell :deep(.sba-open-head),
  .compliance-view-shell :deep(.sba-open-row) {
    animation: sbaSlideIn var(--sba-slide-duration, 260ms) ease-out both;
  }

@media (prefers-reduced-motion: reduce) {
    .compliance-view-shell :deep(.collection-landing-head),
    .compliance-view-shell :deep(.workflow-card),
    .compliance-view-shell :deep(.premium-queue-head),
    .compliance-view-shell :deep(.claim-batch-row),
    .compliance-view-shell :deep(.claim-detail-card),
    .compliance-view-shell :deep(.empty-review-state),
    .compliance-view-shell :deep(.invoice-review-head),
    .compliance-view-shell :deep(.invoice-filter-card),
    .compliance-view-shell :deep(.invoice-list-card),
    .compliance-view-shell :deep(.invoice-row-card),
    .compliance-view-shell :deep(.invoice-empty-state),
    .compliance-view-shell :deep(.sba-open-head),
    .compliance-view-shell :deep(.sba-open-row) {
    animation: none;
  }
}

@media only screen and (max-width: 900px) {
  .compliance-page-shell {
    width: 92%;
  }
}

@media only screen and (max-width: 600px) {
  .compliance-page-shell {
    margin-top: -10px;
    padding-bottom: 34px;
    width: 94%;
  }

  .compliance-view-shell :deep(.premium-queue-head),
  .compliance-view-shell :deep(.claim-batch-row),
  .compliance-view-shell :deep(.claim-detail-card),
  .compliance-view-shell :deep(.invoice-review-head),
  .compliance-view-shell :deep(.invoice-list-card),
  .compliance-view-shell :deep(.invoice-row-card),
  .compliance-view-shell :deep(.empty-review-state),
  .compliance-view-shell :deep(.invoice-empty-state) {
    border-radius: 6px;
  }
}
</style>
